import config from '@/config';

export const defaultFilterState = {
  favorites: false,
  basfi: false,
  duration: null,
  resources: [],
  area: [],
  intensity: null,
  dimensions: [],
  portal: null,
};

const _getInitialFilter = () => {
  try {
    const storedFilter = JSON.parse(
      window.localStorage.getItem(config.localStorageFilterField)
    );

    // Fix stored filters
    if (storedFilter.area === null) {
      return null;
    }

    if (!Array.isArray(storedFilter.area)) {
      return null;
    }

    if (!Array.isArray(storedFilter.resources)) {
      return null;
    }

    if (!storedFilter.dimensions) {
      return null;
    }

    return storedFilter;
  } catch (e) {
    return null;
  }
};
export const getInitialFilter = () => {
  return (window.__DATA__.user && _getInitialFilter()) || defaultFilterState;
};

export const getInitialIsFilterOpen = () => {
  const { area, duration, intensity, resources } = getInitialFilter();

  return Boolean(area.length || resources.length || duration || intensity);
};

export const getInitialLanguage = () => {
  const storedLanguage = window.localStorage.getItem(
    config.localStorageLanguageField
  );
  const [navigatorLanguage] = (
    navigator.language ||
    navigator.userLanguage ||
    ''
  ).split('-');
  const userLanguage = (window.__DATA__.user || {}).language;

  if (config.availableLanguages.includes(storedLanguage)) return storedLanguage;
  if (config.availableLanguages.includes(userLanguage)) return userLanguage;
  if (config.availableLanguages.includes(navigatorLanguage))
    return navigatorLanguage;

  return config.defaultLanguage;
};



// WEBPACK FOOTER //
// ./src/store/functions.js